import red from '@material-ui/core/colors/red';
import cncUI from './cncui';

export default {
  cncUI,
  mycc: {
    white: '#fff',
    black: '#000',
    main: '#30aba3',
    dark: '#1d6762',
    light: '#eaf7f6',
    paper: '#f7fcfc',
    link: '#3c9dd7',
    button: '#2eaba4',
    buttonDisabled: '#bfeeec',
    lightContrastText: '#83cdc8',
    outlineFormInput: '#268982',
    lightText: '#616161',
    box: '#f5fcfb',
    boxHeader: '#59bcb5',
    label: '#939393',
    formLabel: '#137e74',
    darkText: '#606060',
    error: '#F45656',
    success: '#acdcc0',
    fieldDisabled: '#999999',
    gray: '#e0e0e0',
    lightGray: '#f4f4f4',
    lightBG: '#f7fcfc',
    disableLabel: '#ababab',
    remove: '#b00020',
  },
  primary: {
    main: '#eaeded',
    light: '#eee',
    dark: '#b8bbbb',
    darkContrastText: '#4a4a4a',
    contrastText: '#888888',
  },
  secondary: {
    main: '#30aba3',
    light: '#6effff',
    dark: '#007b74',
    contrastText: '#ffffff',
  },
  text: {
    primary: '#555',
    secondary: '#888',
  },
  error: red,
};
